import axios from "axios";
import END_POINT from "src/config/endpoints.constants";

interface HealthCheckResponse {
  status: string;
}

const HEALTH_CHECK_TIMEOUT = 5000; // 5 seconds

export const checkBackendHealth = async (): Promise<boolean> => {
  try {
    const response = await axios.get<HealthCheckResponse>(
      END_POINT.HEALTH_CHECK,
      {
        timeout: HEALTH_CHECK_TIMEOUT,
      },
    );
    return response.data?.status === "UP";
  } catch {
    return false;
  }
};
